import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from '../../config/config'; // Importing configuration settings

/**
 * Class representing a view for adding information to the agent list.
 * @extends JetView
 */
export default class addInformationaAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the current screen size configuration
        const screen = this.app.config.size;
        // Define available languages for selection
        const lenguages = [
            { id: 'ES', value: 'español (o castellano) (ES)' },
            { id: 'EN', value: 'English (EN)' },
            { id: 'PT', value: 'Portugués (PT)' },
        ];
        // Main configuration object for the UI component
        const main = {
            minWidth: 250, // Minimum width of the component
            cols: [
                {
                    padding: 5, // Padding around the column
                    rows: [
                        {
                            view: 'text', // Text input for login
                            name: 'LoginAccess', // Name of the input field
                            label: _('Login para acceso'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Login para acceso'), // Placeholder text
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'text', // Text input for password
                            name: 'Password', // Name of the input field
                            hidden: profile.PartnerSelected == 8, // Conditionally hide the field based on profile
                            label: _('Clave'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Clave'), // Placeholder text
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State', // Name of the input field
                            localId: 'State:combo', // Local ID for the component
                            label:
                                "<span class='icon-state'></span>" + // Icon for the label
                                _('Estado'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 'A', // Default selected value
                            options: [
                                // Options for the dropdown
                                { id: 'A', value: _('Activo') }, // Active state
                                { id: 'I', value: _('Inactivo') }, // Inactive state
                                { id: 'R', value: _('Retirado') }, // Retired state
                            ],
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'text', // Text input for user name
                            name: 'Name', // Name of the input field
                            label:
                                "<span class='icon-user'></span>" + // Icon for the label
                                _('Nombre del usuario'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre del usuario'), // Placeholder text
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'richselect', // Dropdown for preferred language selection
                            name: 'PreferredLanguage', // Name of the input field
                            localId: 'PreferredLanguage:combo', // Local ID for the component
                            label: _('Idioma preferido:'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: lenguages[0].id, // Default selected value
                            options: lenguages, // Options for the dropdown
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'richselect', // Dropdown for type selection
                            name: 'Type', // Name of the input field
                            label: _('Tipo'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: '0', // Default selected value
                            options: [
                                // Options for the dropdown
                                { id: '0', value: _('Agente') }, // Agent type
                                { id: '1', value: _('Afiliado') }, // Affiliate type
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountryId', // Name of the input field
                            id: 'country', // ID for the component
                            localId: 'Country:combo', // Local ID for the component
                            label:
                                "<span class='icon-language'></span>" + // Icon for the label
                                _('País'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown (to be populated dynamically)
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'richselect', // Dropdown for currency selection
                            name: 'CurrencyId', // Name of the input field
                            id: 'currency', // ID for the component
                            localId: 'Currency:combo', // Local ID for the component
                            label:
                                "<span class='webix_icon mdi mdi-coin'></span>" + // Icon for the label
                                _('Moneda'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown (to be populated dynamically)
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'richselect', // Dropdown for partner selection
                            name: 'Partner', // Name of the input field
                            label: _('Partner'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.PartnerSelected, // Default selected value from profile
                            options: profile.Partners, // Options for the dropdown from profile
                            hidden: !profile.Partners.length > 2, // Conditionally hide the field based on the number of partners
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                    ],
                },
            ],
        };
        // Configuration object for the main options of the UI component
        const options_main = {
            // Margin around the component
            margin: 5,
            // Minimum width of the component
            minWidth: 250,
            // Array of column configurations
            cols: [
                {
                    // Padding inside the column
                    padding: 5,
                    // Array of row configurations
                    rows: [
                        {
                            // Nested rows for the first section
                            rows: [
                                // Label for special status
                                { view: 'label', label: _('Estado especial') },
                                {
                                    // Switch for special status
                                    id: 'SpecialStatus',
                                    value: 1, // Default value (active)
                                    view: 'switch',
                                    onLabel: _('Activo'), // Label when switch is on
                                    offLabel: _('Inactivo'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            // Nested rows for the second section
                            rows: [
                                {
                                    // Label for sales lock status
                                    view: 'label',
                                    label: _('Bloqueado para ventas'),
                                },
                                {
                                    // Switch for locked sales
                                    id: 'Lockedsales',
                                    view: 'switch',
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            // Nested rows for the third section
                            rows: [
                                {
                                    // Label for receipt printing option
                                    view: 'label',
                                    label: _('Imprime recibo caja'),
                                },
                                {
                                    // Switch for printing receipt box
                                    id: 'PrintReceiptBox',
                                    view: 'switch',
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            // Nested rows for the fourth section
                            rows: [
                                { view: 'label', label: _('Permite recargas') }, // Label for recharge permission
                                {
                                    // Switch for allowing recharges
                                    id: 'AllowsRecharges',
                                    view: 'switch',
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                        {
                            // Nested rows for the fifth section
                            rows: [
                                {
                                    // Label for registration activation option
                                    view: 'label',
                                    label: _('Permite activar reg'),
                                },
                                {
                                    // Switch for activating registration
                                    id: 'ActivateRegistration',
                                    view: 'switch',
                                    onLabel: _('Si'), // Label when switch is on
                                    offLabel: _('No'), // Label when switch is off
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for betshop details form.
         * @type {Object}
         * @property {number} margin - Margin around the form.
         * @property {number} minWidth - Minimum width of the form.
         * @property {number} padding - Padding inside the form.
         * @property {Array} cols - Array of column configurations.
         */
        const betshop_details = {
            margin: 5, // Margin around the form
            minWidth: 250, // Minimum width of the form
            padding: 5, // Padding inside the form
            cols: [
                {
                    rows: [
                        // Array of row configurations
                        {
                            view: 'text', // Type of input field
                            name: 'ContactName', // Name of the input field
                            label: _('Nombre del contacto'), // Label for the input field
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre del contacto'), // Placeholder text
                            required: true, // Indicates if the field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when validation fails
                        },
                        {
                            view: 'text',
                            name: 'Document',
                            type: 'number', // Specifies the input type as number
                            label: _('Número cédula'),
                            labelPosition: 'top',
                            placeholder: _('Numero cédula'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Email',
                            label: _('Correo electrónico'),
                            labelPosition: 'top',
                            placeholder: _('Correo electrónico'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Label with an icon
                            labelPosition: 'top',
                            placeholder: _('Descripción'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect', // Dropdown selection field
                            name: 'Concessionaire',
                            id: 'Concessionaire', // Unique identifier for the field
                            localId: 'Concessionaire:combo', // Local identifier for the field
                            label: _('Concesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [], // Options for the dropdown
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'Subconcessionaire',
                            id: 'Subconcessionaire',
                            localId: 'Subconcessionaire:combo',
                            label: _('Subconcesionario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'RegionId',
                            id: 'ProvinceRegion',
                            localId: 'ProvinceRegion:combo',
                            label: _('Provincia/Región'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'richselect',
                            name: 'CityId',
                            id: 'City',
                            localId: 'City:combo',
                            label: "<span class='icon-language'></span>" + _('Ciudad'), // Label with an icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [],
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Address',
                            label: _('Dirección'),
                            labelPosition: 'top',
                            placeholder: _('Dirección'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'District',
                            label: _('Barrio'),
                            labelPosition: 'top',
                            placeholder: _('Barrio'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'Phone',
                            type: 'number', // Specifies the input type as number
                            label: _('Teléfono'),
                            labelPosition: 'top',
                            placeholder: _('Teléfono'),
                            required: true,
                            invalidMessage: _('Campo Requerido'),
                        },
                        {
                            view: 'text',
                            name: 'IP',
                            type: 'number', // Specifies the input type as number
                            label: _('IP'),
                            labelPosition: 'top',
                            placeholder: _('IP'),
                            required: false, // Indicates that this field is optional
                            invalidMessage: _('Campo Requerido'),
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for the right-centered layout.
         * @type {Object}
         * @property {number} margin - The margin around the layout.
         * @property {number} minWidth - The minimum width of the layout.
         * @property {number} padding - The padding inside the layout.
         * @property {Array} cols - An array of column configurations.
         */
        const center_right = {
            margin: 5, // Margin value in pixels
            minWidth: 250, // Minimum width in pixels
            padding: 5, // Padding value in pixels
            cols: [
                {
                    rows: [
                        {
                            view: 'text', // Type of the input view
                            name: 'DailyQuotaReloads', // Unique name for the input field
                            label: _('Limite diario de recargas'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Limite diario de recargas'), // Placeholder text, translated
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when the field is invalid
                        },
                        {
                            view: 'text', // Type of the input view
                            name: 'CommissionReloads', // Unique name for the input field
                            label: _('Comisión recargas'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Comisión recargas'), // Placeholder text, translated
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when the field is invalid
                        },
                    ],
                },
                {
                    rows: [
                        {
                            view: 'text', // Type of the input view
                            name: 'MinimumBet', // Unique name for the input field
                            label: _('Apuesta mínima'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Apuesta mínima'), // Placeholder text, translated
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when the field is invalid
                        },
                        {
                            view: 'text', // Type of the input view
                            name: 'DailyLimit', // Unique name for the input field
                            label: _('Límite diario'), // Label for the input field, translated
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Límite diario'), // Placeholder text, translated
                            required: true, // Indicates that this field is required
                            invalidMessage: _('Campo Requerido'), // Message shown when the field is invalid
                        },
                    ],
                },
            ],
        };
        // Object representing the right section layout configuration
        const right = {
            margin: 5, // Margin around the right section
            rows: [], // Array to hold rows in the right section
        };

        // Object representing the upper section layout configuration
        const upper_section = {
            id: 'b5', // Unique identifier for the upper section
            rows: [
                // Array to hold rows in the upper section
                {
                    collapsed: true, // Indicates if the section is initially collapsed
                    multi: true, // Allows multiple items to be expanded
                    view: 'accordion', // Type of view for the section
                    css: 'betShop', // CSS class for styling
                    margin: 15, // Margin around the upper section
                    responsive: 'b5', // Responsive design identifier
                    cols: [
                        // Array to hold columns in the upper section
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is initially collapsed
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            rows: [
                                // Array to hold rows in the column
                                {
                                    header: _('Datos Principales'), // Header text for the row
                                    body: {
                                        // Body configuration for the row
                                        padding: 10, // Padding inside the body
                                        rows: [
                                            // Array to hold rows in the body
                                            {
                                                margin: 10, // Margin around the column
                                                cols: [main], // Columns to be included in the row
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is initially collapsed
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            rows: [
                                // Array to hold rows in the column
                                {
                                    header: _('Datos Agente'), // Header text for the row
                                    body: {
                                        // Body configuration for the row
                                        rows: [betshop_details], // Rows to be included in the body
                                    },
                                },
                            ],
                        },
                        {
                            multi: true, // Allows multiple items to be expanded
                            view: 'accordion', // Type of view for the column
                            css: 'betShop', // CSS class for styling
                            collapsed: false, // Indicates if the column is initially collapsed
                            paddingY: 10, // Vertical padding for the column
                            type: 'clean', // Type of column layout
                            hidden: true, // Indicates if the column is hidden
                            rows: [
                                // Array to hold rows in the column
                                {
                                    header: _('Datos Configuración'), // Header text for the row
                                    body: {
                                        // Body configuration for the row
                                        padding: 10, // Padding inside the body
                                        rows: [
                                            // Array to hold rows in the body
                                            {
                                                margin: 10, // Margin around the column
                                                cols: [options_main], // Columns to be included in the row
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        // Define a buttons configuration object
        const buttons = {
            // Set margin for buttons
            margin: 10,
            // Array of button configurations
            cols: [
                {},
                {
                    // Button to clear the form
                    view: 'button',
                    value: _('Limpiar'), // Localized button label
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Clear the root component's data
                        this.getRoot().clear();
                    },
                },
                {
                    // Button to save the form data
                    view: 'button',
                    value: _('Guardar'), // Localized button label
                    type: 'form', // Specify button type as form
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Retrieve values from the root component
                        const newdata = this.getRoot().getValues();
                        // Set SpecialStatus based on the value of the corresponding checkbox
                        if ($$('SpecialStatus').getValue() == 1) {
                            newdata.SpecialStatus = 'A'; // Active
                        } else {
                            newdata.SpecialStatus = 'I'; // Inactive
                        }
                        // Set Lockedsales based on the value of the corresponding checkbox
                        if ($$('Lockedsales').getValue() == 1) {
                            newdata.Lockedsales = 'S'; // Sales locked
                        } else {
                            newdata.Lockedsales = 'N'; // Sales not locked
                        }
                        // Set PrintReceiptBox based on the value of the corresponding checkbox
                        if ($$('PrintReceiptBox').getValue() == 1) {
                            newdata.PrintReceiptBox = 'S'; // Print receipt enabled
                        } else {
                            newdata.PrintReceiptBox = 'N'; // Print receipt disabled
                        }
                        // Set AllowsRecharges based on the value of the corresponding checkbox
                        if ($$('AllowsRecharges').getValue() == 1) {
                            newdata.AllowsRecharges = 'S'; // Recharges allowed
                        } else {
                            newdata.AllowsRecharges = 'N'; // Recharges not allowed
                        }
                        // Set ActivateRegistration based on the value of the corresponding checkbox
                        if ($$('ActivateRegistration').getValue() == 1) {
                            newdata.ActivateRegistration = 'S'; // Registration activated
                        } else {
                            newdata.ActivateRegistration = 'N'; // Registration not activated
                        }
                        // Validate the form before saving
                        if (this.getRoot().validate()) {
                            // Trigger save event with new data
                            this.app.callEvent('agentList:save', [newdata]);
                        } else {
                            // Show error message if validation fails
                            webix.message({
                                title: _('¡Error!'), // Localized error title
                                type: 'alert-error', // Error message type
                                text: _('Completa los campos...'), // Localized error message
                            });
                        }
                    },
                },
            ],
        };
        // Set the UI to full screen mode
        webix.ui.fullScreen();

        // Return a configuration object for a Webix form
        return {
            // Define the view type as 'form'
            view: 'form',

            // Assign a unique identifier to the form
            id: 'formId',

            // Enable vertical scrolling for the form
            scroll: 'y',

            // Define the layout of the form with rows containing buttons and upper section
            rows: [buttons, upper_section],

            // Configuration for elements within the form
            elementsConfig: {
                // Event handlers for the form elements
                on: {
                    // Handle the change event for form elements
                    onChange: function (newv, oldv) {
                        // Validate the form whenever a change occurs
                        this.validate();
                    },
                },
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} form - The form object to initialize.
     */
    init(form) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Preserve the context of 'this' for use in callbacks
        var vthis = this;

        // Event listener for saving the agent list
        this.on(this.app, 'agentList:save', (data) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set the content type for the request
                })
                .post(devConfig.geturlApi() + 'Agent/SaveAgent', data, {
                    // Handle error response
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error')); // Display error message
                    },
                    // Handle successful response
                    success: function (text, data, XmlHttpRequest) {
                        var json = JSON.parse(text); // Parse the JSON response
                        webix.message(_('Guardado')); // Display success message
                        // Navigate to the agent information list with the user ID
                        vthis.show('agentListManagement?user=' + json.id + '/agent.informationAgentList');
                    },
                });
        });

        // Fetch the list of agent countries
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set the content type for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Display error message
                },
                // Handle successful response
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize property names
                            .replace(/"Name"/g, '"value"'),
                    );
                    var optionsProvinceRegions = $$('country').getList(); // Get the country list
                    optionsProvinceRegions.clearAll(); // Clear existing options
                    optionsProvinceRegions.parse(data.Data); // Populate with new data
                },
            });

        // Fetch agents with two levels of hierarchy
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set the content type for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels2', '', {
                // Handle error response
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! ')); // Display error message
                },
                // Handle successful response
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize property names
                            .replace(/"Name"/g, '"value"'),
                    );
                    // Check if there are children in the data
                    if (data.Data.Children == null) {
                        $$('Concessionaire').hide(); // Hide the Concessionaire dropdown
                        $$('Subconcessionaire').hide(); // Hide the Subconcessionaire dropdown
                    } else {
                        var options = $$('Concessionaire').getList(); // Get the Concessionaire list
                        options.clearAll(); // Clear existing options
                        options.parse(data.Data.Children); // Populate with new data
                    }
                },
            });

        // Trigger an event to update the form with user parameters
        this.app.callEvent('form:update', [this.getParam('user', true)]);

        // Event listener for updating customer data
        this.on(
            this.app,
            'customer:updatedata',
            (person) => form.setValues(person), // Set form values with updated customer data
        );

        // Event listener for selecting a person
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Set form values with selected person data

        // Event listener for changes in the country dropdown
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionscurrencies = $$('currency').getList(); // Get the currency list
            optionscurrencies.clearAll(); // Clear existing options
            optionscurrencies.parse(optionscountries.currencies); // Populate with new currency data
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get the ProvinceRegion list
            optionsProvinceRegions.clearAll(); // Clear existing options
            optionsProvinceRegions.parse(optionscountries.departments); // Populate with new department data
        });

        // Event listener for changes in the ProvinceRegion dropdown
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province region
            var optionsCity = $$('City').getList(); // Get the City list
            optionsCity.clearAll(); // Clear existing options
            optionsCity.parse(optionsProvinceRegions.cities); // Populate with new city data
        });

        // Event listener for changes in the Concessionaire dropdown
        $$('Concessionaire').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected concessionaire
            var optionsCity = $$('Subconcessionaire').getList(); // Get the Subconcessionaire list
            optionsCity.clearAll(); // Clear existing options
            optionsCity.parse(optionsProvinceRegions.Children); // Populate with new sub-concessionaire data
        });
    }

    /**
     * Retrieves and localizes combo options for positions, tags, and cities.
     * Updates the respective combo boxes with localized values.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization function
        let p_options = webix.copy(getPositions()); // Copying positions options
        p_options.map((x) => (x.value = _(x.value))); // Localizing position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing positions into the combo

        let t_options = webix.copy(getTags()); // Copying tags options
        t_options.map((x) => (x.value = _(x.value))); // Localizing tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing tags into the combo

        let c_options = webix.copy(getCities()); // Copying cities options
        c_options.map((x) => (x.value = _(x.value))); // Localizing city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing cities into the combo
    }
}

// FILE DOCUMENTED
